import React, { useId, useState } from 'react';
import '../style/Experience.css';
import { publicUrl } from '../utils/publicUrl';

function ExperienceDescription({ bullets, description }) {
  if (bullets && bullets.length > 0) {
    return (
      <ul className="experience-card__bullets">
        {bullets.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }
  if (description) {
    return <p className="experience-card__text">{description.trim()}</p>;
  }
  return null;
}

function WorkExperienceItem({ experience }) {
  const { title, company, employmentType, dateRange, location, logo, bullets, description } = experience;
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const label = `${open ? 'Hide' : 'Show'} details for ${company}`;

  return (
    <article
      data-aos="fade-up"
      data-aos-once
      className={`experience-card${open ? ' experience-card--open' : ''}`}
    >
      <div className="experience-card__logo-wrap">
        {logo ? (
          <img className="experience-card__logo" src={publicUrl(logo)} alt={`${company} logo`} loading="lazy" />
        ) : (
          <div className="experience-card__logo experience-card__logo--placeholder" aria-hidden />
        )}
      </div>
      <div className="experience-card__body">
        <h3 className="experience-card__title">{title}</h3>
        <p className="experience-card__company-line">
          <span className="experience-card__company">{company}</span>
          {employmentType ? <span className="experience-card__type"> · {employmentType}</span> : null}
        </p>
        <p className="experience-card__meta">
          {dateRange}
          {location ? ` · ${location}` : ''}
        </p>
      </div>
      <button
        type="button"
        className="experience-card__toggle"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="experience-card__chevron" aria-hidden />
        <span className="experience-card__toggle-label">{label}</span>
      </button>
      <div id={panelId} className="experience-card__panel" role="region" aria-label={`${title} at ${company}`}>
        <div className="experience-card__panel-inner" aria-hidden={!open}>
          <div className="experience-card__description">
            <ExperienceDescription bullets={bullets} description={description} />
          </div>
        </div>
      </div>
    </article>
  );
}

export default function WorkExperienceList({ experiences }) {
  return (
    <div className="work-experience-list">
      {experiences.map((experience) => (
        <WorkExperienceItem
          key={`${experience.company}-${experience.dateRange}`}
          experience={experience}
        />
      ))}
    </div>
  );
}
